export interface ContractAiUpdateAccessState {
    hasAiFeaturesAddOn: boolean;
    isAiSpendingExhausted: boolean;
}

/**
 * Why the AI-assisted update cannot be used, as a translation key, or undefined when it can.
 *
 * Unlike the obligation scan this needs only the AI Features add-on: it writes contract fields, not
 * obligations. The add-on comes before the spending limit because owning it is what makes spending matter
 * at all.
 */
export function getContractAiUpdateBlockedTranslationKey(state: ContractAiUpdateAccessState): string | undefined {
    if (!state.hasAiFeaturesAddOn) {
        return "aiAddOnPurchaseTooltip";
    }

    if (state.isAiSpendingExhausted) {
        return "aiSpendingLimitReached";
    }

    return undefined;
}
